import { atom } from 'jotai';
import { isMobile } from 'react-device-detect';

import type { FormMode, Event } from '../../Data/types';

export const showFilterAtom = atom<boolean>(!isMobile);

export const showEventPaneAtom = atom<boolean>(false);
export const eventPaneLoadingAtom = atom<boolean>(false);
export const showDeleteConfirmationDialogAtom = atom<boolean>(false);
export const formModeAtom = atom<FormMode>('new');
export const isSeriesEventActionAtom = atom<boolean>(false);
export const selectedEventAtom = atom<Event | null>(null);

// notification toaster messages for success and error messages object
export const notificationMessageAtom = atom<{
  messageTitle: string;
  messageBody?: string;
  intent?: 'info' | 'warning' | 'error' | 'success';
} | null>(null);
